<template>
  <div>
    <div
      id="cat-loading"
      class="cat-loading"
      style="display: none"
      aria-hidden="true"
    >
      <!--<div class="blur"></div>-->
      <!--<div class="blur"></div>-->
      <!--<div class="blur"></div>-->
      <!--<div class="blur"></div>-->
      <!--<div class="blur"></div>-->
      <div class="wrapper">
        <ul class="loader">
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <span>{{ displayMessage }}</span>
      </div>
    </div>
    <div
      ref="processingText"
      class="visually-hidden"
      role="status"
      aria-live="assertive"
    >
      {{ feedbackProcessing ? displayMessage : "" }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject } from "vue";
import jQuery from "jquery";
import { defaultResolveTxt } from "@/components/field-element";

export default defineComponent({
  setup() {
    // Inject the global value
    const resolveTxt = inject("resolveTxt", defaultResolveTxt);

    return {
      resolveTxt
    };
  },
  name: "CatThrobber",
  props: {
    loadingMessage: {
      type: String,
      description: "Message displayed when loader is active."
    },
    minMillis: {
      type: Number,
      default: 500,
      description: "Determines time in  milliseconds the loader will be active."
    },
    delayMillis: {
      type: Number,
      default: 50,
      description:
        "Determines time in milliseconds loader will be delayed before activated."
    }
  },
  inject: {
    loadingImage: {
      name: "loadingImage",
      default: "../resource/app/images/ajax-loader.svg"
    }
  },
  data: function () {
    return {
      blocking: false,
      feedbackProcessing: false,
      startMillis: null,
      requestMillis: null,
      displayMessage: this.loadingMessage
        ? this.loadingMessage
        : this.resolveTxt("skin.processing.label", "Processing your request"),
      showTimeout: null,
      screenReaderTimeout: null
    };
  },
  methods: {
    show: function (options) {
      // Clear any existing screen reader timeout
      if (this.screenReaderTimeout) {
        clearTimeout(this.screenReaderTimeout);
        this.screenReaderTimeout = null;
      }

      this.feedbackProcessing = false;

      if (this.requestMillis == null) {
        this.requestMillis = new Date().getTime();
      }
      const block = () => {
        if (this.requestMillis) {
          this.startMillis = new Date().getTime();
          if (window.isTestMode) {
            jQuery("#cat-loading").show();
          } else {
            jQuery("#cat-loading").fadeIn();
          }
          this.$emit("ui-loading", { loading: true });
        }
      };
      if (options.text) {
        this.displayMessage = options.text;
      }

      /*
        The 300ms delay was a value that seemed to work consistently with getting NVDA to announce the "proocessing request" text.
        There is an open github issue here for NVDA - https://github.com/nvaccess/nvda/issues/17662
      */
      this.screenReaderTimeout = setTimeout(() => {
        if (this.requestMillis) {
          this.feedbackProcessing = true;
          this.$forceUpdate(); // Ensure Vue reactivity triggers
        }
      }, 300);

      if (options.delayMillis === 0) {
        block();
      } else {
        this.showTimeout = window.setTimeout(
          block,
          options.delayMillis ? options.delayMillis : this.delayMillis
        );
      }
    },
    hide: function () {
      // Clear screen reader timeout if hiding before announcement
      if (this.screenReaderTimeout) {
        clearTimeout(this.screenReaderTimeout);
        this.screenReaderTimeout = null;
      }

      if (this.requestMillis) {
        if (this.showTimeout) {
          clearTimeout(this.showTimeout);
          this.showTimeout = null;
        }
        var timeShown = new Date().getTime() - this.startMillis;
        if (timeShown > this.minMillis) {
          this.doHide();
        } else {
          window.setTimeout(this.doHide, this.minMillis - timeShown);
        }
      }
      this.feedbackProcessing = false;
    },
    doHide: function () {
      if (window.isTestMode) {
        jQuery("#cat-loading").hide();
      } else {
        jQuery("#cat-loading").fadeOut(100, function () {
          jQuery("#cat-loading").css({ opacity: "" });
        });
      }
      this.displayMessage = this.loadingMessage
        ? this.loadingMessage
        : this.resolveTxt("skin.processing.label", "Processing your request");
      this.requestMillis = null;
      this.startMillis = null;
      this.$emit("ui-loading", { loading: false });
    }
  },
  mounted: function () {
    var t = this;
    document.addEventListener("ui-unblock", function () {
      t.hide();
    });
    document.addEventListener("ui-block", function (event) {
      t.show(event.detail);
    });
  },
  beforeUnmount: function () {
    if (this.showTimeout) {
      clearTimeout(this.showTimeout);
      this.showTimeout = null;
    }
    if (this.screenReaderTimeout) {
      clearTimeout(this.screenReaderTimeout);
      this.screenReaderTimeout = null;
    }
  }
});
</script>
